// Initial State
export const filterInitialState = {
  fromDate: "",
  fromDateStatus: "unchecked",
  toDate: "",
  toDateStatus: "unchecked",
  client: "",
  clientStatus: "unchecked",
  user: "",
  userStatus: "unchecked",
  interviewFromDate: "",
  interviewFromDateStatus: "unchecked",
  interviewToDate: "",
  interviewToDateStatus: "unchecked",
  onboardJoiningFromDate: "",
  onboardJoiningFromDateStatus:"unchecked",
  onboardJoiningToDate: "",
  onboardJoiningToDateStatus:"unchecked",
  onboardSrFromDate: "",
  onboardSrFromDateStatus:"unchecked",
  onboardSrToDate: "",
  onboardSrToDateStatus:"unchecked",

  // add more fields here if needed
};

// Reducer
export const filterReducer = (state, action) => {
  const name = action?.name;
  const value = action?.value;

  switch (name) {
    case "reset":
      return { ...filterInitialState };

    case "fromDate":
    case "interviewFromDate":
    case "interviewToDate":
    case "onboardJoiningFromDate":
    case "onboardJoiningToDate":
    case "onboardSrFromDate":
    case "onboardSrToDate":
    case "toDate": {
      const regex = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
      const status = !value ? "unchecked" : regex.test(value) ? "success" : "error";
      return { ...state, [name]: value, [name + "Status"]: status };
    }

    default: {
      const status = value ? "success" : "unchecked";
      return { ...state, [name]: value, [name + "Status"]: status };
    }
  }
};

// Generic onChange handler
export const handleChangeDispatch = (eventOrValue, dispatch, selectMeta = null) => {
  if (!eventOrValue?.target && selectMeta?.name) {
    dispatch({ name: selectMeta.name, value: eventOrValue });
  } else {
    const { name, value } = eventOrValue.target;
    dispatch({ name, value });
  }
};
